import { createStore } from 'vuex';
import API from "../config/api.js";
import { ENDPOINTS } from "../config/variables.js";
import { auth } from '@/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth'
import { signOut } from 'firebase/auth'
//import { signOut } from 'firebase/auth'
import { toast } from "vue3-toastify";
import router from "@/router";

export default createStore({
  state: {
    isLoading: false,
    currentUser: {},
    apiToken: "",
    isLoggedIn: null,
    errorMessage: null,
  },
  getters: {
    getCurrentUser: (state) => state.currentUser,
    getUserToken: (state) => state.apiToken,
    isLoading: (state) => state.isLoading,
  },
  actions: {
    async login({ commit }, credentials) {
      try {
         console.log(credentials, "Backin ");
        let response = await signInWithEmailAndPassword(
          auth,
          credentials.email,
          credentials.password,
        )
        let respToken = response.user?.accessToken;
        console.log(respToken, "me")
        let respp = await API.post(ENDPOINTS.USER_LOGIN, { token: respToken, type: 'customer', });
        console.log(respp, "login Console")
        commit('SET_USER', respp.data)
        if (respp) {
          return respp.data;
        }
      } catch (error) {
        error.message;
        console.log(error.code);
        toast.error(error.code, {
          position: toast.POSITION.TOP_RIGHT,
          timeout: 5000,
          duration: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: true,
          icon: true,
          rtl: false,
        });
      }

    },
    updateUserProfileAction: async ({ commit }, data) => {
      console.log("i am in action")
      let response = await API.post(ENDPOINTS.UPDATE_USER_PROFILE, data);
      console.log(response, "Updated User Detail");
      if (response.status == 200) {
        commit("updateUserProfileMutation", response.data);
        return response.data;
      } else {
        return response.data;
      }
    },

    async logout({ commit }) {
      await signOut(auth);
      toast.success("Successuffly Logout !", {
        position: toast.POSITION.TOP_RIGHT,
        timeout: 5000,
        duration: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: true,
        icon: true,
        rtl: false
      });
      router.push("/user-login");
      commit('CLEAR_USER')
    },
    deleteUser: async ({ commit }) => {
      try {
        console.log("Account Delete Function")
        let delresponse = await API.delete(ENDPOINTS.USER_DELETE)
        console.log(delresponse, "account delete")
        commit('CLEAR_USER');
        return delresponse;
      } catch (error) {
        console.log(error.delresponse)
      }



    }

  },
  mutations: {
    SET_USER(state, data) {
      state.currentUser = data.user;
      state.apiToken = data.user.api_token;
      localStorage.setItem("user", JSON.stringify(data.user));
      localStorage.setItem("token", data.user.api_token);
      localStorage.setItem("isLoggedIn", "true");
    },

    CLEAR_USER(state,) {
      state.currentUser = null;
      state.apiToken = null;
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("isLoggedIn");
    },
    updateUserProfileMutation: (state, data) => {

      localStorage.setItem("user", JSON.stringify(data.user));
      state.currentUser = data.user;
      console.log(state.currentUser.name, "Updated Current User");
    },
  },
  modules: {
  }
})
